export default "__VITE_ASSET__d7942fdd__"